
<div class="progress-layout">
    <div class="progress-section">
        <div class="progress-bar-container">
            <div class="ts-progress-bar">
                <div class="ts-progress-fill" [style.width.%]="getSelectedPercentage()"></div>
            </div>
        </div>
        <div class="percentage-progress" [ngClass]="{'status-valid valid-allocation-quantity': getSelectedPercentage() === 100, 'status-danger': getSelectedPercentage() > 100}">
            Total Qty to Allocate: {{selectedQuantity}} | {{ (getSelectedPercentage() | number:'1.2-2')+'%'}}
        </div>
    </div>
    <div class="actions-section">
        <div class="allocate-actions">
            <button class="btn-primary form-button" aria-label="Allocate" (click)="onAllocateClickHandler()"
                [disabled]="selectedQuantity !== expectedQuantity">Allocate</button>
            <button class="btn-outlined form-button" aria-label="Search" (click)="onResetClickHandler()"
                type="reset">Reset</button>
        </div>
    </div>
</div>
